import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Utils
import dataHandler from "@Utils/dataHandler";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";
import InvitationsCrud from "./Modals/InvitationsCrud";

// Styles
import styles from "./styles.module.css";

const invitations = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [openInvitationsCrud, setOpenInvitationsCrud] = useState("");
	const [openConfirmModal, setOpenConfirmModal] = useState(false);

	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const [profileData, setprofileData] = useState([]);
	const [groupsList, setGroupsList] = useState([]);

	// filter

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const invitationsPromise = dataHandler({
				dispatch,
				url: "invitations",
				params: defaultParams,
			});
			const profileListPromise = dispatch(genericAction({ method: "get", route: "profiles/all" }));
			const groupsPromise = dispatch(genericAction({ method: "get", route: "groups/all" }));
			const [invitationsResponse, profileListResponse, groupsResponse] = await Promise.all([
				invitationsPromise,
				profileListPromise,
				groupsPromise,
			]);

			setFilteredItems(invitationsResponse.items);
			setFilteredCount(invitationsResponse.count);

			setprofileData(profileListResponse);
			setGroupsList(groupsResponse);
		})();
	}, []);

	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "invitations", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
		}
	};

	const handleButtom = async (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "send":
				apiData("send", item);
				break;
			case "cancel":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	// modal handlers
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenInvitationsCrud(true);
	};
	const apiData = async (name, item) => {
		switch (name) {
			case "cancel": {
				await dispatch(genericAction({ method: "post", route: `/invitations/cancelInvitation/${item.id}` }));
				setOpenConfirmModal(false);
				break;
			}
			case "send": {
				await dispatch(genericAction({ method: "post", route: `invitations/resendInvitation/${item.id}` }));
				setOpenConfirmModal(false);
				break;
			}
			default: {
				break;
			}
		}
		const invitationsPromise = await dataHandler({
			dispatch,
			url: "invitations",
			params: defaultParams,
		});

		setFilteredCount(invitationsPromise.count);
		setFilteredItems(invitationsPromise.items);
	};

	const hiddenButtonEraser = (item) => {
		if (item.status === "Pendiente") {
			return true;
		}
		return false;
	};
	const hiddenButtonResend = (item) => {
		if (item.status === "Cancelada" || item.status === "Vencida" || item.status === "Pendiente") {
			return true;
		}
		return false;
	};

	return (
		<Screen hasSidebar hasHeader headerTitle="Invitar Usuario">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [
										{
											content: "cancel",
											color: "#b43333",
											onClick: "cancel",
											type: "icon",
											visible: hiddenButtonEraser,
										},
										// { content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
										{
											content: "send",
											color: "#2070DF",
											onClick: "send",
											type: "icon",
											visible: hiddenButtonResend,
										},
									],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Estado",
									key: "status",
									format: "string",
									dataPosition: "center",
									headerPosition: "center",
									width: 1,
								},
								{
									label: "Correo",
									key: "email",
									format: "string",
									dataPosition: "left",
									headerPosition: "left",
									width: 2,
								},
								{
									label: "Fecha Enviada",
									dataPosition: "center",
									headerPosition: "center",
									key: "createdDate",
									format: "dateTime",
									width: 2,
								},
								{
									label: "Perfil",
									key: "profile.name",
									format: "string",
									dataPosition: "left",
									headerPosition: "left",
									width: 15,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem" }}
							print={{
								printHeader: { company: companyName, title: "Invitar Usuario", user: userName },
							}}
						/>
					</div>
				</div>
			</div>

			{openInvitationsCrud && (
				<InvitationsCrud
					apiData={apiData}
					tableValue={tableValue}
					onClose={() => {
						setOpenInvitationsCrud(false);
					}}
					modalCrud={modalOption}
					profileList={profileData}
					groupsList={groupsList}
				/>
			)}

			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Cancelar"
					content="Está seguro que desea cancelar la invitación a"
					focus={tableValue.email}
					onConfirm={() => {
						apiData("cancel", tableValue);
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		companyName: company.name,
		userName: user.name,
	};
}
invitations.propTypes = {
	dispatch: PropTypes.func,
	user: PropTypes.array,
	groupList: PropTypes.array,
	companyName: PropTypes.string,
};
export default connect(mapStateToProps)(invitations);
